import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'attribute',
    serviceName: 'shopadmin',
    query: gql`
      query attribute($ids: [String]) {
        attribute(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
